<template>
  <div
    class="opple-ota-card"
  >
    <div
      class="opple-ota-card_head"
    >
      <span v-if="tianMu" style="color:#2481ea">{{ deviceModel?.DeviceName }}</span>
      <span>{{ status.text }}</span>
    </div>
    <div
      class="opple-ota-card_main"
    >
      <ul>
        <li v-if="type === 2">
          {{ $t('deviceMsg.firmwareNo') }}: <span>{{ info.SourceType || 0 }}</span>
        </li>
        <li>
          {{ $t('deviceMsg.currentversion') }}:
          <span>{{ info.LocalVersion }}</span>
          <span v-if="info.isLasted"> ({{ $t('deviceMsg.uptodate') }})</span>
        </li>
        <li>{{ $t('deviceMsg.newversion') }}: <span>{{ info.LatestedVersion }}</span></li>
      </ul>
    </div>
    <div
      class="opple-ota-card_foot"
    >
      <OtaProgress
        v-if="isShowOtaBtn"
        :ota-status="info.otaStatus"
        :has-error="info.hasError"
        :progress="info.progress"
        :ota-info="info.otaInfo"
      />
      <div v-if="isShowOtaBtn" class="opple-ota-card_foot_btn async-ota-actions">
        <OppleAuth
          v-if="status.isShowStartBtn"
          code="OTADevice"
          inline
        >
          <OppleButton
            size="mini"
            :disabled="disabledBoot || status.isStartDisabled"
            :loading="isLoadingReqOta"
            @click="startImmediateOta"
          >
            {{ $t('otaUpdate.upgradeNow') }}
          </OppleButton>
        </OppleAuth>
        <OppleAuth
          v-if="status.isShowStartBtn"
          code="OTADevice"
          inline
        >
          <OppleButton
            size="mini"
            type="default"
            :disabled="disabledBoot"
            :loading="isLoadingReqOta"
            @click="startAutoOta"
          >
            {{ $t('otaUpdate.automaticUpgrade') }}
          </OppleButton>
        </OppleAuth>
        <OppleAuth
          v-if="status.isShowCancelBtn"
          code="OTADevice"
          inline
        >
          <OppleButton
            size="mini"
            type="default"
            :loading="isLoadingReqCancelOta"
            @click="stopOta"
          >
            {{ $t('sync.close') }}
          </OppleButton>
        </OppleAuth>
      </div>
    </div>
  </div>
</template>
<script>
import OppleButton from '@/components/Base/OppleButton/index.vue'
import OtaProgress from './OtaProgress.vue';
import { OTA_STATUS_ENUMS } from './enums';

export default {
  components: {
    OppleButton,
    OtaProgress
  },
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    otaStatus: {
      type: Number,
      default: 0
    },
    deviceModel: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: Number,
      default: 1,
    },
    upOtaIndex: {
      type: Number,
      default: 0
    },
    isDisabledGuide: {
      type: Boolean,
      default: false
    },
    isLoadingReqOta: {
      type: Boolean,
      default: false
    },
    isLoadingReqCancelOta: {
      type: Boolean,
      default: false
    },
    tianMu: {
      type: Boolean,
      default: false
    },
    showKeyUp: {
      type: Boolean,
      default: true
    },
    cardIndex: {
      type: Number,
      default: 0
    },
    isShowOtaBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      disabledBoot: false,
    }
  },

  computed: {
    status() {
      const text = `${this.$t('otatask.firmware')}${this.cardIndex + 1}`;

      if (this.info.LatestedVersion === '-') {
        return {
          text,
          isShowStartBtn: false,
          isStartDisabled: false,
          isShowCancelBtn: false
        }
      }

      if (this.type === 0) {
        return {
          text,
          isShowStartBtn: false,
          isStartDisabled: true,
          isShowCancelBtn: false
        }
      }

      if (this.info.isLasted) {
        return {
          text,
          isShowStartBtn: false,
          isStartDisabled: true,
          isShowCancelBtn: false
        }
      }

      if (!this.deviceModel.IsOnline) {
        return {
          text,
          isShowStartBtn: false,
          isStartDisabled: this.isDisabledGuide,
          isShowCancelBtn: false
        }
      }

      const isShowStartBtn = [
        OTA_STATUS_ENUMS.PADDING,
        OTA_STATUS_ENUMS.STOP,
      ].includes(this.otaStatus);

      const isShowCancelBtn = this.info.otaStatus === OTA_STATUS_ENUMS.PROCESSING;

      return {
        text,
        isShowStartBtn,
        isStartDisabled: this.isDisabledGuide,
        isShowCancelBtn
      }
    }
  },

  watch: {
    status: {
      handler() {
        this.$emit('showUpLevelBtn', this.status, this.upOtaIndex)
      },
      immediate: true
    }
  },

  methods: {
    startImmediateOta() {
      this.$emit('startImmediateOta', this.upOtaIndex);
    },
    startAutoOta() {
      this.$emit('startAutoOta', this.upOtaIndex);
    },
    stopOta() {
      this.$emit('stopOta', this.upOtaIndex);
    },
  }
}
</script>

<style lang="scss" scoped>
.opple-ota-card {
  display: inline-block;
  margin-right: 10px;
  border: 1px solid rgb(233, 236, 244);
  border-radius: 5px;
  min-width: 289px;
  font-size: 12px;
  text-align: left;
  &_head {
    min-height: 17px;
    padding: 16px 10px;
    background: rgb(248, 248, 248);
    border-bottom: 1px solid rgb(233, 236, 244);
    text-align: center;
  }

  &_main {
    padding: 10px 10px 6px;

    li {
      padding: 2px 0;
    }
  }

  &_foot {
    display: flex;
    min-height: 36.5px;
    justify-content: space-between;
    align-items: center;
    padding: 6px 11px;

    &_btn {
      display: flex;
      width: auto;
      justify-content: flex-end;
      gap: 8px;
    }
  }
}
</style>
